import { UrlContextParams } from '../utils/urlUtil'
import { useReduxSelector } from '../hooks/useReduxSelector'
import { DATA_SOURCE_TYPE, DATA_SOURCE_TYPES, GOVERNANCE_SUPPORTED_DATASOURCES } from '../constants'
import { ACTION_FETCH_IDP_ID, fetchIdpId } from '../features/dataSources/dataSourcesSlice'
import { getActionState } from '../reducers/requestReducer'
import { STATES } from '../interfaces'
import { useEffect, useMemo } from 'react'
import { useDispatch } from 'react-redux'

const useIsGovernanceEnabled = (params: {
  context: UrlContextParams
  datasourceId?: string
  datasourceType?: DATA_SOURCE_TYPES
}) => {
  const { context, datasourceId: datasourceIdProp, datasourceType: datasourceTypeProp } = params
  const accessControl = useReduxSelector((state) => state.featureFlags?.accessControl)
  const idpId = useReduxSelector((state) => state.dataSources.selectedDatasourceIdpId)
  const actionState = useReduxSelector(() => getActionState(ACTION_FETCH_IDP_ID))
  const isLoading = actionState === STATES.pending

  const dispatch = useDispatch()

  const datasourceId = context.contextFilters.datasourceId || datasourceIdProp
  const datasourceType = context.queryParams[DATA_SOURCE_TYPE] || datasourceTypeProp
  const isGovernanceSupportedDatasource = useMemo(
    () =>
      datasourceId &&
      datasourceType &&
      GOVERNANCE_SUPPORTED_DATASOURCES.includes(datasourceType as DATA_SOURCE_TYPES),
    [datasourceId, datasourceType]
  )
  const isIdpNotRequired = [DATA_SOURCE_TYPES.salesForce].includes(
    datasourceType as DATA_SOURCE_TYPES
  )

  useEffect(() => {
    if (datasourceId && isGovernanceSupportedDatasource && idpId === undefined && !isLoading) {
      dispatch(fetchIdpId(datasourceId))
    }
  }, [
    datasourceId,
    accessControl,
    datasourceType,
    isGovernanceSupportedDatasource,
    idpId,
    isLoading,
    dispatch
  ])

  if (isIdpNotRequired) {
    return Boolean(datasourceId ? isGovernanceSupportedDatasource && accessControl : accessControl)
  }

  const result = Boolean(
    datasourceId ? isGovernanceSupportedDatasource && accessControl && idpId : accessControl
  )

  return result
}

export default useIsGovernanceEnabled
